export const siteInfo = {
  name: "佐佐木希官方粉丝资讯站",
  description: "汇聚佐佐木希最新写真、出道经历、影视作品、时尚造型及粉丝应援资讯",
  ogImage: "https://sazakigallery.github.io/og-image.jpg",
  baseUrl: "https://sazakigallery.github.io",
};